@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package chartsproject.app.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.StringResource

private object CommonMainString0 {
  public val app_name: StringResource by 
      lazy { init_app_name() }

  public val bar_chart: StringResource by 
      lazy { init_bar_chart() }

  public val bar_stacked_chart: StringResource by 
      lazy { init_bar_stacked_chart() }

  public val chart_basic: StringResource by 
      lazy { init_chart_basic() }

  public val chart_custom: StringResource by 
      lazy { init_chart_custom() }

  public val github_url: StringResource by 
      lazy { init_github_url() }

  public val github_url_content_description: StringResource by 
      lazy { init_github_url_content_description() }

  public val line_chart: StringResource by 
      lazy { init_line_chart() }

  public val multi_line_chart: StringResource by 
      lazy { init_multi_line_chart() }

  public val pie_chart: StringResource by 
      lazy { init_pie_chart() }

  public val themes_content_description: StringResource by 
      lazy { init_themes_content_description() }
}

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("app_name", CommonMainString0.app_name)
  map.put("bar_chart", CommonMainString0.bar_chart)
  map.put("bar_stacked_chart", CommonMainString0.bar_stacked_chart)
  map.put("chart_basic", CommonMainString0.chart_basic)
  map.put("chart_custom", CommonMainString0.chart_custom)
  map.put("github_url", CommonMainString0.github_url)
  map.put("github_url_content_description", CommonMainString0.github_url_content_description)
  map.put("line_chart", CommonMainString0.line_chart)
  map.put("multi_line_chart", CommonMainString0.multi_line_chart)
  map.put("pie_chart", CommonMainString0.pie_chart)
  map.put("themes_content_description", CommonMainString0.themes_content_description)
}

internal val Res.string.app_name: StringResource
  get() = CommonMainString0.app_name

private fun init_app_name(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:app_name", "app_name",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/chartsproject.app.generated.resources/values/strings.commonMain.cvr", 10, 24),
    )
)

internal val Res.string.bar_chart: StringResource
  get() = CommonMainString0.bar_chart

private fun init_bar_chart(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:bar_chart", "bar_chart",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/chartsproject.app.generated.resources/values/strings.commonMain.cvr", 35, 21),
    )
)

internal val Res.string.bar_stacked_chart: StringResource
  get() = CommonMainString0.bar_stacked_chart

private fun init_bar_stacked_chart(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:bar_stacked_chart", "bar_stacked_chart",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/chartsproject.app.generated.resources/values/strings.commonMain.cvr", 57, 41),
    )
)

internal val Res.string.chart_basic: StringResource
  get() = CommonMainString0.chart_basic

private fun init_chart_basic(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:chart_basic", "chart_basic",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/chartsproject.app.generated.resources/values/strings.commonMain.cvr", 99, 27),
    )
)

internal val Res.string.chart_custom: StringResource
  get() = CommonMainString0.chart_custom

private fun init_chart_custom(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:chart_custom", "chart_custom",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/chartsproject.app.generated.resources/values/strings.commonMain.cvr", 127,
    28),
    )
)

internal val Res.string.github_url: StringResource
  get() = CommonMainString0.github_url

private fun init_github_url(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:github_url", "github_url",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/chartsproject.app.generated.resources/values/strings.commonMain.cvr", 219,
    70),
    )
)

internal val Res.string.github_url_content_description: StringResource
  get() = CommonMainString0.github_url_content_description

private fun init_github_url_content_description(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:github_url_content_description", "github_url_content_description",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/chartsproject.app.generated.resources/values/strings.commonMain.cvr", 156,
    62),
    )
)

internal val Res.string.line_chart: StringResource
  get() = CommonMainString0.line_chart

private fun init_line_chart(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:line_chart", "line_chart",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/chartsproject.app.generated.resources/values/strings.commonMain.cvr", 290,
    26),
    )
)

internal val Res.string.multi_line_chart: StringResource
  get() = CommonMainString0.multi_line_chart

private fun init_multi_line_chart(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:multi_line_chart", "multi_line_chart",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/chartsproject.app.generated.resources/values/strings.commonMain.cvr", 317,
    40),
    )
)

internal val Res.string.pie_chart: StringResource
  get() = CommonMainString0.pie_chart

private fun init_pie_chart(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:pie_chart", "pie_chart",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/chartsproject.app.generated.resources/values/strings.commonMain.cvr", 358,
    21),
    )
)

internal val Res.string.themes_content_description: StringResource
  get() = CommonMainString0.themes_content_description

private fun init_themes_content_description(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:themes_content_description", "themes_content_description",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/chartsproject.app.generated.resources/values/strings.commonMain.cvr", 380,
    58),
    )
)
